import graph from "@irati/utils/services/graph"

import {team} from "./team"


const service = {}

export const survey = `
  id
  reference
  Etag
  createdAt
  openedAt
  status
  test
  questionStats(team: $team, driverId: $driverId) @include(if: $withQuestionStats) {
    answers {
      value
      count
    }
    answersAverage
    timesAnswered
    timesSkipped
    timesSelected
  }
  commentCount
  responseCount(team: $team) @include(if: $withResponseCount)
  sendCount
  preferences {
    questionSelectionType
    sendToAll
    teams {
      results {
        ${team}
      }
    }
  }
`

service.list = (variables, options = {}) => {
  const query = `
    query Surveys(
      $tenant: String!,
      $scheduleId: String,
      $orderBy: String,
      $orderDirection: String,
      $test: Int,
      $team: String,
      $driverId: String,
      $minOpenedAt: String,
      $limit: Int,
      $offset: Int,
      $withQuestionStats: Boolean = false,
      $withResponseCount: Boolean = false,
    ) {
      surveys(
        tenant: $tenant,
        scheduleId: $scheduleId,
        orderBy: $orderBy,
        orderDirection: $orderDirection,
        team: $team,
        minOpenedAt: $minOpenedAt,
        limit: $limit,
        offset: $offset,
        test: $test
      ){
        results {
          ${survey}
        }
        offset
        limit
        count
        cursor
        total
      }
    }
  `

  return graph({query, variables}, options)
    .then((response) => response.surveys)
}

service.update = ({fields, ...rest}, options) => {
  const query = `
   mutation UpdateSurveyMutation($survey: SurveyInput!) {
    survey(survey: $survey){
     id
    }
  }
  `
  return graph({query, variables: {survey: fields, ...rest}}, options).then((response) => response)
}

export const getSurveys = service.list
export const updateSurvey = service.update

export default service
